<template>
  <div class="time_container" >
    <p :class = "(required ? 'required_label' : '')">
      {{ custom_label }}
    </p>
    <div class="time_body">
      <v-select
        v-model="h_selected"
        class="time-width"
        :items="h_list"
        @change="changeMinutes"></v-select>
      <span class="pa-2 divider" >:</span>
      <v-select
        v-model = "m_selected"
        :disabled="minute_disabled"
        class="time-width"
        :items="m_list"
        @change="setTime"></v-select>
    </div>

    <span v-if = "error_msg && error_msg.length > 0">{{ error_msg.join(',') }}</span>
  </div>
</template>

<script>

export default {
  name: 'TimePickerSelect',
  props: {
    custom_label: String,
    time_default: String,
    min: String,
    max: String,
    step: {
      type: Number,
      default: 1,
    },
    required: Boolean,
    error_msg: Array
  },
  data() {
    return {
      time: null,
      dropdown_time: false,
      minute_disabled: true,
      h_selected: null,
      m_selected: null,
      min_splitted: [],
      max_splitted: [],
      default_time_splitted: [],
      h_list: [],
      m_list: []
    }
  },
  created() {
    this.min_splitted = this.timeToSplit(this.min)
    this.max_splitted = this.timeToSplit(this.max)
    this.default_time_splitted = this.timeToSplit(this.time_default)
    const start = this.min_splitted[0]
    let end = this.max_splitted[0]
    this.h_list = this.rangeNumber(start, end, 1, (start > end ? 24 : false)).sort((a,b)=> {
      if (start > end && a.value === 0){
        return 1
      }else if (start > end && b.value === 0){
        return -1
      }else{
        return a.value - b.value
      }

    })
    if (this.time_default && this.default_time_splitted.length == 2){
      this.h_selected = this.default_time_splitted[0]
      this.populateListMinutes()
      this.m_selected = this.default_time_splitted[1]
      this.minute_disabled = false
    }
  },
  watch:{
    time(newValue, oldValue){
      this.$emit('callback_on_change_time', newValue)
    },
  },
  methods: {
    timeToSplit(time){
      return time.split(":").map( n => Number(n) )
    },
    rangeNumber(min, max, step = 1, max_value = false){
      max = max_value ? max + max_value : max
      return Array.from({ length: (max - min) / step + 1}, (_, i) => {
        let min_to_use = (min + i * step)
        if (max_value && min_to_use >= max_value){
          min_to_use -= max_value
        }

        return  {
          "text":min_to_use.toString().padStart(2, '0'),
          "value": min_to_use
        }
      })

    },
    populateListMinutes(){
      if(this.h_selected == this.min_splitted[0] && this.h_selected == this.max_splitted[0] ){
        this.m_list = this.rangeNumber(this.min_splitted[1], this.max_splitted[1], this.step)
      }else if(this.h_selected == this.min_splitted[0]){
        this.m_list = this.rangeNumber(this.min_splitted[1], 59, this.step)
      }else if( this.h_selected == this.max_splitted[0] ){
        this.m_list = this.rangeNumber(0, this.max_splitted[1], this.step)
      }else{
        this.m_list = this.rangeNumber(0, 59, this.step)
      }
    },
    changeMinutes(){
      this.populateListMinutes()
      this.m_selected = this.m_list[0].value
      this.minute_disabled = false
      this.setTime()
    },
    setTime(){

      this.time = this.h_selected + ":" + this.m_selected
    }

  }
}
</script>

<style>
div.time_container{
  width: auto;
}
div.time_container div.time_body{
  display: flex;
}
.time-width.v-select{
  width: 55px;
  max-width: 55px;
}
span.divider{
  height: 50px;
  font-size: 14px;
  font-weight: bold;
  line-height: 50px;
}
p.required_label{
  height: 15px;
  font-size: 13px;
}
.required_label::before{
  content: '*';
  color: red;
  font-size: 13px;
}
</style>
